import { takeLatest } from "redux-saga/effects";

import chatActionCreators from "../../actions/chat";
import sagasUtils from "../../../utils/sagas.utils";

export function* watchSyncReplyRooms() {
  yield takeLatest(chatActionCreators.syncReplyRooms.toString(), sagasUtils.syncChatRooms);
}
